/*
  bootstraper for react components
*/

require('babel-polyfill');
require('../quickView/QuickViewBootstrap');
require('../pdp/PDPBootstrap');



// WEBPACK FOOTER //
// ./src/reactjs/utils/bootstrap.js